import React from 'react';
import { Table, Button, Badge, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { QuestionCircleFill } from 'react-bootstrap-icons';

const EstoqueItensTab = ({ estoque, handleOpenAdjustModal, handleMinimoChange }) => {

  const getStatusBadge = (item) => {
    const quantidade = item.quantidade_em_estoque;
    const minimo = item.estoque_minimo;

    if (quantidade <= 0) {
      return <Badge bg="danger">Zerado</Badge>;
    }
    if (quantidade <= minimo) {
      return <Badge bg="warning">Baixo</Badge>;
    }
    return <Badge bg="success">OK</Badge>;
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Referencial para o sistema alertar sobre a necessidade de reposição.
    </Tooltip>
  );

  return (
    <>
      <Table striped bordered hover responsive="sm">
        <thead>
          <tr>
            <th>Material</th>
            <th>Fabricante</th>
            <th className="text-center">Estoque Atual</th>
            <th className="text-center">
              Estoque Mínimo{' '}
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <QuestionCircleFill size={12} style={{ cursor: 'pointer', verticalAlign: 'middle' }} />
              </OverlayTrigger>
            </th>
            <th className="text-center">Status</th>
            <th className="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {estoque.map((item) => (
            <tr key={item.id}>
              <td>{item.tipo_material?.nome || 'N/A'}</td>
              <td>{item.fabricante || '-'}</td>
              <td className="text-center">{item.quantidade_em_estoque} {item.tipo_material?.unidade_medida}</td>
              <td className="text-center" style={{ maxWidth: '150px' }}>
                <Form.Control
                  type="number"
                  size="sm"
                  defaultValue={item.estoque_minimo}
                  onBlur={(e) => handleMinimoChange(item.id, e.target.value)}
                  className="text-center"
                />
              </td>
              <td className="text-center">{getStatusBadge(item)}</td>
              <td className="text-center">
                <Button variant="outline-primary" size="sm" onClick={() => handleOpenAdjustModal(item)}>Ajustar</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default EstoqueItensTab;